import { Component, HostBinding, ChangeDetectionStrategy, ViewContainerRef, forwardRef, AfterContentChecked, ChangeDetectorRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NeighborChange } from '../../../comun/recipient-services/changes/neighbor-change';
import { ChangeType } from '../../../enums/change-type.enum';
import { ChangeComponent } from '../../../modify-shipping/change-component';
import { IGOOGLEANALITYCSAWARE_INJECTIONTOKEN } from '../../../google-analitycs-aware';




@Component({
  selector: 'app-neighbor-change',
  templateUrl: './neighbor-change.component.html',
  styleUrls: ['./neighbor-change.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: IGOOGLEANALITYCSAWARE_INJECTIONTOKEN,
      useExisting: forwardRef(() => NeighborChangeComponent)
    }
  ]
})
export class NeighborChangeComponent extends ChangeComponent implements AfterContentChecked {
  @HostBinding('class.container') true;
  change = (this.sesion.changesAvailable.find(change => {
    return change.type == ChangeType.NeighborDelivery;
  }) as NeighborChange);

  constructor(
    modalService: BsModalService,
    vcr: ViewContainerRef,
    private cdr: ChangeDetectorRef) {
    super(modalService, vcr);
  }
  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }
}

